import moment from "moment";

export const getDateString = (date) => {

    if (!date) {
        throw new Error('Incorrect value provided for the date param');
    };

    const dateString = moment(date).format('DD/MM/YYYY HH:mm');

    return dateString;
};